<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {

    name: 'PedidoDetalles',

    props: {
        value: {
            type: Object
        },
        resumenPedido: {
            type: Array
        },
        devoluciones: {
            type: Boolean
        },
        readonly: {
            type: Boolean,
            default: true
        }
    },

    data: () => {
        return {
            workingValue: {
                devolucionesCFG: []
            }
        }
    },

    computed: {
        ...mapGetters(['authGetUser']),
        selectedFields(){
            let mat = ['elemento', 'cantidad'];
            if(this.devoluciones){
                // mat.push('precio')
                mat.push({key: 'devolucion', label: 'Devolución'})
                mat.push({key: 'devolucion_subtotal', label: 'Monto'})
            } else {
                if(this.authGetUser.tipoUsuario == 'Admin')
                    mat.push('costo')
                mat.push('precio')
                mat.push('total')
            }
            return mat
        }
    },

    methods: {
        attachDevsIfEmpty(){
            if(this.resumenPedido.length && !this.workingValue.devolucionesCFG.length){
                this.workingValue.devolucionesCFG = _.map(_.clone(this.resumenPedido), item => {
                    if(typeof item.devolucion == undefined){
                        item.devolucion = 0
                        item.devolucion_subtotal = 0
                    }
                    return {
                        devolucion: 0,
                        devolucion_subtotal: 0,
                        id_pk: item.id_pk,
                        idpedido_fk: item.idpedido_fk,
                        idpresentacion_fk: item.idpresentacion_fk,
                        cantidad: item.cantidad,
                        precio: item.precio,
                        costo: item.costo,
                        tipo: item.tipo,
                        total: item.total
                    }
                })
            }
        },
        updateDevSummary(){
            let toEmmit = {
                costo: 0,
                precio: 0
            }
            _.forEach(this.workingValue.devolucionesCFG, item => {
                toEmmit.costo += parseFloat(item.costo) * parseInt(item.devolucion)
                toEmmit.precio += item.devolucion_subtotal
            })
            this.$emit( 'updated', toEmmit )
        },
        workingIndexUpdate(dIndex){
            try {
                let cloned = _.cloneDeep(this.workingValue.devolucionesCFG)
                cloned[dIndex].devolucion_subtotal = (cloned[dIndex].total / cloned[dIndex].cantidad * cloned[dIndex].devolucion)
                this.workingValue.devolucionesCFG = cloned
                let fullForm = _.clone(this.value)
                fullForm.devolucionesCFG = _.clone(cloned)
                this.$emit('input', fullForm)
                this.updateDevSummary()
            } catch(e){
                console.warn(e)
            }
        }
    },

    beforeMount(){
        if(_.isObjectLike(this.value) && _.isObjectLike(this.value.devolucionesCFG))
            this.workingValue.devolucionesCFG = _.clone(this.value.devolucionesCFG)
        this.attachDevsIfEmpty()
    },

    mounted(){
        this.$nextTick(() => {
            // setTimeout(()=>{
            if(this.workingValue.devolucionesCFG.length)
                this.workingIndexUpdate(this.workingValue.devolucionesCFG.length - 1)
                console.log('ticked!')
            // }, 1999)
        })
    }
}
</script>

<template>
    <div id="PedidoDetalles">
        <b-table small striped :items="resumenPedido" :fields="selectedFields">

            <template #cell(devolucion)="data">
                <input class="form-control" type="number" 
                    v-model="workingValue.devolucionesCFG[data.index].devolucion"
                    :readonly="readonly"
                    :max="data.item.cantidad" min="0"
                    @change="workingIndexUpdate(data.index)"/>
            </template>

            <template #cell(devolucion_subtotal)="data">
                {{workingValue.devolucionesCFG[data.index].devolucion_subtotal | currency}}
            </template>

        </b-table>
    </div>
</template>

<style lang="less">
    #PedidoDetalles {
        .table th, .table td {
            vertical-align: middle;
        }
    }
</style>